module.exports = __webpack_public_path__ + "static/media/wander_woman.b2f17d9d.png";